// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1IEiG","large":"styles_large__1JNnF"};